import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {
    isDefined,
    NotificationDataInstanceToken,
    NotificationIdentifierModel,
    NotificationStatusInstanceToken,
} from '@evorait/pace-core';
import { LogInstanceToken } from '@evorait/pace-logging';
import { map } from 'rxjs/operators';

export const NotificationExistsGuard: CanActivateFn = (route) => {
    const id = new NotificationIdentifierModel(
        route.paramMap.get('frontid') || '',
        route.paramMap.get('qmnum') || '',
        route.paramMap.get('manum') || '',
    );

    const notificationService = inject(NotificationDataInstanceToken);
    const notificationStatusService = inject(NotificationStatusInstanceToken);
    const log = inject(LogInstanceToken);
    const router = inject(Router);

    return notificationStatusService.isNotificationCompleted(id).pipe(
        map((isNotificationCompleted) => {
            if (!isDefined(notificationService.getNotificationByIdentifier(id))) {
                const errorMessage = `NotificationExistsGuard: the requested notification "${id.toString()}" is not available in the NdpHeaderSet.`;
                log.error(errorMessage);
                return router.createUrlTree(['/main']);
            } else if (isNotificationCompleted) {
                const errorMessage = `NotificationExistsGuard: the requested notification "${id.toString()}" was recently completed.`;
                log.error(errorMessage);
                return router.createUrlTree(['/main']);
            }
            return true;
        }),
    );
};
